import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {UnsubscribeService} from "../../../services/unsubscribe.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-unsubscribe',
  standalone: true,
  templateUrl: './unsubscribe.component.html',
  styleUrl: './unsubscribe.component.css'
})
export class UnsubscribeComponent implements OnInit {
  subscriptionToken: any;
  confirmationMessage: any;
  private readonly route = inject(ActivatedRoute);
  private readonly unsubscribeService = inject(UnsubscribeService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.subscriptionToken = params['subscriptionToken'];
      this.unsubscribe();
    });
  }

  unsubscribe() {
    if (!this.subscriptionToken) return;

    this.unsubscribeService.unsubscribe(this.subscriptionToken).then((response) => {
      this.confirmationMessage = response;
    }).catch((error) => {
      this.confirmationMessage = error.error.Message;
    });
  }
}
